import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateLevel = (resource, id, { structureId, levelId, ...values }) => {
  return axios.put(
    `/api/${resource}/${id}/setup/level_structures/${structureId}/levels/${levelId}`,
    values
  );
};

export const useUpdateLevel = (resource, id, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => updateLevel(resource, id, values),
    onSuccess: () => {
      enqueueSnackbar('Level successfully updated', { variant: 'success' });
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(
        error?.response?.data?.description || error?.message || 'Some error occured',
        {
          variant: 'error',
        }
      );
    },
  });
};
